/* Built In Imports */
/* External Imports */
import { Box, Image } from '@chakra-ui/react';
import MediaEmbedV2 from '@components/Embeds/MediaEmbedV2';
import SectionTitle from '@components/Headings/SectionTitle';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import SingleLineText from '@components/UI/SingleLineText';
import { LeftQuote } from '../components/Icon/LeftQuote';
/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const Offerings = ({ sectionContent, region, language }) => {
    return (
        <Box
            paddingTop={{ sm: "", base: "", md: "100px", xl: "50px" }}
            paddingBottom={{ sm: "", base: "", lg: "" }}
            marginTop={{ base: "-40px", sm: "-40px", xl: "0px" }}
        >
            <Box>
                <SectionTitle
                    titleObj={sectionContent[0]}
                    titleDecoration={sectionContent[0]?.titleDecoration}
                    color="white"
                    fontSize={{ base: "30px", sm: "30px", md: "37px" }}
                    mx={{ base: '17px', md: 'auto' }}
                />
            </Box>
            <Box marginTop={{ base: "-35px", sm: "-35px", xl: "-30px" }} width={{ sm: "315px", base: "315px", md: "623px" }} mx={"auto"} >
                <SingleLineText fontSize="20px" textAlign="center" color="#E8DDD0" sectionContent={sectionContent[1]} />
            </Box>
            <Box marginBottom={{ base: "", sm: "", md: "56px" }} textAlign={'center'} className='imgblock'>
                <Image src={sectionContent[2]?.image?.url} width={{base:'201px', md:'auto'}} alt=""/>
            </Box>

            <Box display={"flex"}
                flexDirection={{ base: "column", sm: "column", xl: "row" }}
                gap={{ base: '0px', xl: '80px' }}
                justifyContent={{ sm: "center", base: "center", xl: "start" }}
                alignItems={{ sm: "center", base: "center", xl: "start" }}
                px={{ base: "", sm: "", md: "32px", lg: "57px" }}

            >
                <Box width={{ base: "286px", sm: "286px", md: '350px', lg: "364px" }}
                    display={"flex"} flexDirection={"column"}
                    alignItems={"center"}
                    fontFamily={"FedraSansStd-book"}
                    mt={{ base: "30px", xl: "50px" }}
                >
                    <LeftQuote />
                    <Box
                        color="#F8F8F8"
                        textAlign="center"
                        fontFamily={"FedraSansStd-book"}
                        fontSize={{ base: '18px', lg: '22px' }}
                        fontStyle="italic"
                        fontWeight="400"
                        lineHeight="32px"
                        marginTop={"20px"}
                    >
                        {sectionContent[3]?.quote}
                    </Box>
                    <LazyLoadImageComponent
                        src="https://static.sadhguru.org/d/46272/1663673930-sadhguru_signature_white.svg"
                        w="137px"
                        h="64px"
                        alt="isha logo"
                        objectFit="contain"
                        my={{ base: '30px', md: '30px' }}
                    />
                </Box>
                <Box
                    pos={'relative'}
                    maxWidth={'678px'}
                    w={{ base: '100%' }}
                    mt={{ md: '20px' }}
                >
                    <MediaEmbedV2 sectionContent={sectionContent[4]}
                        width={{ base: '90%', md: '762px' }}
                        style={{ zIndex: "10" }}
                    />
                </Box>
            </Box>
            <style jsx global>
                {`
                    .imgblock img {
                        display: inline-block !important;
                    }
                        
                `}
            </style>
        </Box>
    );
};

export default Offerings;
